import { render, staticRenderFns } from "./ItemWithImage.vue?vue&type=template&id=931c691e&scoped=true&"
import script from "./ItemWithImage.vue?vue&type=script&lang=js&"
export * from "./ItemWithImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "931c691e",
  null
  
)

export default component.exports